<div class="container-fluid tp-box" [@flipState]="flip">
	<div class="row tp-box__side tp-box__back" *ngIf="flip === 'active'">
		<div class="card">
			<div class="card-header card-header-danger card-header-icon" (click)="toggleFlip(false, '')">
				<div class="card-icon pointer">
					<i class="material-icons">meeting_room</i>
				</div>
				<h3 class="card-title">{{ title }}</h3>
			</div>

			<div class="row m-0 g-3 px-4 py-3">
				<!-- Date Range Picker -->
				<div class="col-md-6">
				 <mat-form-field appearance="fill">
				   <mat-label>Enter a date range</mat-label>
				   <mat-date-range-input [formGroup]="range" [rangePicker]="picker" (dateChange)="onDateRangeChange($event)">
					 <input matStartDate formControlName="start" placeholder="Start date">
					 <input matEndDate formControlName="end" placeholder="End date">
				   </mat-date-range-input>
				   <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
				   <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
				   <mat-date-range-picker #picker></mat-date-range-picker>
				 
				   <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>
				   <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
				 </mat-form-field>

				  
				</div>




				<!-- Action Buttons -->
				<div class="col-md-6 mt-2">
					<div>
						<button class="btn btn-outline-primary btn-sm me-2" (click)="loadData()" [disabled]="sending">
							<i class="material-icons align-middle">refresh</i> Refresh
						</button>
						<ng-container *ngIf="filteredData && !sending">
							<button class="btn btn-success btn-sm me-2" (click)="exportXls()" *ngIf="data">
								<i class="fa fa-file-excel-o"></i> XLS
							</button>
							<button class="btn btn-danger btn-sm me-2" (click)="exportPdf()" *ngIf="data">
								<i class="fa fa-file-pdf-o"></i> PDF
							</button>
						</ng-container>
						<span *ngIf="sending">
							<svg class="spinner" width="55" height="55" viewBox="0 0 66 66">
								<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30" />
							</svg>
						</span>
					</div>
				</div>
			</div>



			<!-- Table -->
			<div class="card-body" *ngIf="viewing">
				<!-- Search input -->
				<div class="row px-4 pb-2">
					<div class="col-md-12 text-right">
						<label for="searchKeyword" class="form-label fw-semibold">Search</label>
						<input type="text" id="searchKeyword" [(ngModel)]="searchTerm" (input)="onSearchChange()" class="form-control shadow-sm" placeholder="Type to filter…" />
					</div>
				</div>

				<h5 class="mb-3 fw-semibold"># Customers {{ total }}</h5>
				<div class="table-responsive" #print_table>
					<table class="table table-striped table-hover align-middle">
						<thead class="table-dark">
							<tr>
								<th class="pointer" (click)="sort('debtorno')">
									Customer#
									<i class="material-icons sort-icon" *ngIf="sortColumn==='debtorno'">
										{{ sortDirection==='asc' ? 'arrow_drop_up' : 'arrow_drop_down' }}
									</i>
								</th>
								<th class="pointer" (click)="sort('name')">
									Name
									<i class="material-icons sort-icon" *ngIf="sortColumn==='name'">
										{{ sortDirection==='asc' ? 'arrow_drop_up' : 'arrow_drop_down' }}
									</i>
								</th>
								<th class="pointer" (click)="sort('address1')">
									Address 1
									<i class="material-icons sort-icon" *ngIf="sortColumn==='address1'">
										{{ sortDirection==='asc' ? 'arrow_drop_up' : 'arrow_drop_down' }}
									</i>
								</th>
								<th class="pointer" (click)="sort('address3')">
									City
									<i class="material-icons sort-icon" *ngIf="sortColumn==='address3'">
										{{ sortDirection==='asc' ? 'arrow_drop_up' : 'arrow_drop_down' }}
									</i>
								</th>
								<th class="pointer text-left" (click)="sort('address4')">
									Region
									<i class="material-icons sort-icon" *ngIf="sortColumn==='address4'">
										{{ sortDirection==='asc' ? 'arrow_drop_up' : 'arrow_drop_down' }}
									</i>&nbsp;&nbsp;&nbsp;
								</th>
								<th class="pointer text-left" (click)="sort('address5')">
									Postal
									<i class="material-icons sort-icon" *ngIf="sortColumn==='address5'">
										{{ sortDirection==='asc' ? 'arrow_drop_up' : 'arrow_drop_down' }}
									</i>
									&nbsp;&nbsp;&nbsp;
								</th>
								<th class="pointer" (click)="sort('salesmanname')">
									Sales Person
									<i class="material-icons sort-icon" *ngIf="sortColumn==='salesmanname'">
										{{ sortDirection==='asc' ? 'arrow_drop_up' : 'arrow_drop_down' }}
									</i>

								</th>
								<th class="pointer" (click)="sort('lastseen')">
									Last Seen
									<i class="material-icons sort-icon" *ngIf="sortColumn==='lastseen'">
										{{ sortDirection==='asc' ? 'arrow_drop_up' : 'arrow_drop_down' }}
									</i>
								</th>
								<th class="pointer" (click)="sort('totalspend')">
									Total Spend
									<i class="material-icons sort-icon" *ngIf="sortColumn==='totalspend'">
										{{ sortDirection==='asc' ? 'arrow_drop_up' : 'arrow_drop_down' }}
									</i>
								</th>
								<th class="pointer" (click)="sort('avgspend')">
									Avg Spend
									<i class="material-icons sort-icon" *ngIf="sortColumn==='avgspend'">
										{{ sortDirection==='asc' ? 'arrow_drop_up' : 'arrow_drop_down' }}
									</i>

								</th>
							</tr>
						</thead>

						<tbody>
							<tr *ngFor="let d of filteredData" class="align-middle">
								<td class="py-2 px-3">
									<a [routerLink]="'/customers/view/' + d.debtorno" class="fw-semibold text-decoration-none">
										{{ d.debtorno }}
									</a>
								</td>
								<td class="py-2 px-3">{{ d.name }}</td>
								<td class="py-2 px-3">{{ d.address1 }}</td>
								<td class="py-2 px-3">{{ d.address3 }}</td>
								<td class="py-2 px-3">{{ d.address4 }}</td>
								<td class="py-2 px-3">{{ d.address5 }}</td>
								<td class="py-2 px-3">
									<span *ngIf="d.salesmanname">{{ d.salesmanname.name }}</span>
								</td>
								<td class="py-2 px-3">{{ d.lastseen }}</td>
								<td class="py-2 px-3 text-end">{{ d.totalspend | currency }}</td>
								<td class="py-2 px-3 text-end">{{ d.avgspend | currency }}</td>
							</tr>
						</tbody>

					</table>
				</div>
			</div>


		</div>
	</div>

	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip === 'inactive' ? '' : 'd-none'">
		<div class="card card-stats">
			<div class="card-header card-header-danger card-header-icon" (click)="toggleFlip(data, title)">
				<div class="card-icon pointer">
					<i class="material-icons">meeting_room</i>
				</div>
				<p class="card-category">{{ title }}</p>
				<h3 class="card-title">
					<span *ngIf="total">{{ total }}</span>
					<span *ngIf="!data">
						<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
							<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
						</svg>
					</span>
				</h3>
				<small>
					<p class="card-category text-info text-justify mt-3 text-right">
						&nbsp;
					</p>
				</small>
			</div>
			<div class="card-footer">
				<div class="stats pointer">
					<a (click)="toggleFlip(data, title)">
						<i class="material-icons">content_copy</i> View Now
					</a>
				</div>
			</div>
		</div>
	</div>
</div>